import { createFileRoute } from '@tanstack/react-router'
import { number, object, optional, parse } from 'valibot'

import { fetchDcs, type FetchDcsQuery } from '@/features/dcs/api'

// dcs/-models から import していたが、dcs/ サブツリー削除に伴いインライン化
// (PR #3433 レビュー指摘 https://github.com/simount/logi-go-tms/pull/3433#pullrequestreview-4308227313)
const dcsSearchSchema = object({
  page: optional(number()),
  status: optional(number())
})

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/in-house/'
)({
  validateSearch: (search) => parse(dcsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  loader: async ({
    abortController,
    deps,
    params: { tenantKey },
    context: { auth }
  }) => {
    const query: FetchDcsQuery = {
      tenantKey,
      page: deps.page,
      // ユーザーが所属する拠点のみ取得する（全件取得だと selectedDcId の初期値がユーザー非所属 DC になる）
      query: { userId: auth.user.id }
    }
    return {
      authUser: auth.user,
      dcs: (await fetchDcs(query, abortController.signal)).data
    }
  }
})
